import * as z from "zod";

export const getWarehouseForProduct = {
  name: "getWarehouseForProduct" as const,
  input: z.object({ variantId: z.string() }),
  output: z.object({ warehouseName: z.string().optional() }),
};
